import CloseIcon from "@mui/icons-material/Close";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  Checkbox,
  ClickAwayListener,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grow,
  Link,
  MenuItem,
  Paper,
  Popper,
} from "@mui/material";
import { useGoogleLogin } from "@react-oauth/google";
import { isAxiosError } from "axios";
import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  ACCOUNT_CONFIGS,
  CHECK_ID_URL,
  INIT_PERSONAL_INFO,
  LOGIN_TYPE,
  INIT_TAX_INFO,
  initialSelectedPhoneCountry,
  COMPANY_RANGE,
} from "../../assets/data/common";
import FacebookIcon from "../../assets/images/logo/FacebookIcon";
import GoogleIcon from "../../assets/images/logo/GoogleIcon";
import US from "../../assets/images/flag/US.png";
import VN from "../../assets/images/flag/VN.png";
import logo_light from "../../assets/images/logo/CheckIDBioSense_light.svg";
import ChevronDown10pxSvg from "../../assets/images/icons/ChevronDown10pxSvg";
import { inviteDecode } from "../../axios/Invitation/InvitationApi";
import { loginSSO } from "../../axios/Login/loginApi";
import { signupBusiness } from "../../axios/Signup/SignupApi";
import CustomInput from "../../components/CustomInput";
import CustomPasswordInput from "../../components/CustomPasswordInput";
import { getInfoByTaxcode } from "../../axios/Taxcode/TaxcodeApi";
import { useGetGeneralPolicyCountry } from "../../hooks/useGeneralService";
import DoneIcon from "@mui/icons-material/Done";
import ErrorIcon from "@mui/icons-material/ErrorOutline";
import Tooltip from "@mui/material/Tooltip";
import {
  BlueOutlinedButton,
  ControlpanelPrimaryButton,
  ControlpanelSecondaryButton,
  GoogleOutlinedButton,
  GrayIconButton,
  PrimaryButton,
  PrimaryButtonFullWidth,
} from "../../components/StyledButton";
import { CustomDialog, NavbarLanguageMenuList } from "../../components/StyledComponents";
import { useAuth } from "../../context/AuthContext";
import { useLoading } from "../../context/LoadingContext";
import {
  useConnectWS,
  useGetDeviceDetails,
  useReadCard,
} from "../../hooks/useCheckid";
import { EmailRegex, PasswordRegex } from "../../utils/regex/Regex";
import { LinkBlue, StyledLink, StyledLinkBlue } from "./../../components/StyledLink";
import CustomSelect from "../../components/CustomSelect";
import { checkCompany } from "../../axios/Company/CompanyApi";
import {
  getInfoByCitizen,
} from "../../axios/User/UserApi";
import {
  generateRandomString,
  setHeaderCompanyId,
} from "../../utils/Function/commonFunction";
import { useNavigate } from "react-router-dom";
import { parse, format, isValid, set } from "date-fns";
import { infoGetByPPersonalID, updateKeyCloak } from "../../axios/Account/AccountApi";
import { message } from "antd";
import CustomSpinner from "../../components/CustomSpinner";
import { changeLanguage } from "../../redux/language/reducer";
import i18n from "../../n18i";

const Signup = () => {
  const navigate = useNavigate();
  const [show, hide] = useLoading();
  const { profile, refreshProfile, infoUserSignUp, dataConfig } = useAuth();
  const { t, i18n: i18nHook } = useTranslation();
  const dispatch = useDispatch();
  const connectWS = useConnectWS();
  const readCard = useReadCard();
  const getDevice = useGetDeviceDetails();
  const [personalInfo, setPersonalInfo] = useState(INIT_PERSONAL_INFO);
  const params = useSearchParams();
  const inviteCode = params[0].get("inviteCode");
  const language = useSelector((state) => state.languageR.language);
  const anchorRefLanguage = useRef(null);
  const [openLanguage, setOpenLanguage] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isVerify, setIsVerify] = useState(false);
  const [isMissingSoftware, setIsMissingSoftware] = useState(false);
  const [open, setOpen] = useState(false);
  const [openDetailTaxID, setOpenDetailTaxID] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const [userSignUp, setUserSignUp] = useState([])
  const [taxInfo, setTaxInfo] = useState(INIT_TAX_INFO);
  const { data: countries } = useGetGeneralPolicyCountry();
  const [selectedPhoneCountry, setSelectedPhoneCountry] = useState(
    initialSelectedPhoneCountry
  );
  const [agree, setAgree] = useState(false);

  const currentLang = i18nHook.language?.startsWith("vi") ? "vi" : "en";
  const currentFlag = currentLang === "vi" ? VN : US;

  const handleChangeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    dispatch(changeLanguage(lang));
    localStorage.setItem("i18nextLngId", lang === "vi" ? "1" : "2");
    setOpenLanguage(false);
  };

  const raw = localStorage.getItem(
    dataConfig.key_session_storage
  );
  const [consentData, setConsentData] = useState(null);

  const getPublicIP = async () => {
    try {
      const res = await fetch("https://api.ipify.org?format=json");
      const data = await res.json();
      return data.ip;
    } catch (err) {
      return "unknown";
    }
  };

  const INIT_DATA = {
    firstName: infoUserSignUp.signUpFirstName,
    lastName: infoUserSignUp.signUpLastName,
    personalID: "",
    email: infoUserSignUp.email,
    // password: '',
    taxCode: "",
    signUpFirstName: infoUserSignUp.signUpFirstName,
    signUpLastName: infoUserSignUp.signUpLastName,
    phone: "",
    country: initialSelectedPhoneCountry.alpha3Code,
    organizationSize: COMPANY_RANGE[0].value,
    fullName: "",
    nameFirst: infoUserSignUp.signUpFirstName,
    nameLast: infoUserSignUp.signUpLastName,
    city: "",
    address: "",
    employeeCode: "",
  };
  const [validationMessages, setValidationMessages] = useState(INIT_DATA);
  const [formData, setFormData] = useState(INIT_DATA);
  const skipBlurRef = useRef(false);
  const [onBlurEvent, setonBlurEvent] = useState(false);
  const generalSettingDateFormat = "dd/MM/yyyy";

  function dg2ToImage(base64, cutLength = 84) {
    // const fullBytes = base64ToByteArray(base64);
    const binaryStr = atob(base64);
    const len = binaryStr.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryStr.charCodeAt(i);
    }
    const trimmedBytes = bytes.slice(cutLength);
    let binaryBase64 = "";
    for (let i = 0; i < trimmedBytes.length; i++) {
      binaryBase64 += String.fromCharCode(trimmedBytes[i]);
    }

    return btoa(binaryBase64);
  }

  const formatDate = (dateString, dateFormat) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;
    try {
      return format(date, dateFormat);
    } catch {
      return dateString;
    }
  };

  const handleUpdateKeycloak = async () => {
    const profile1 = JSON.parse(raw);
    const sub = profile1.profile.sub;

    const payload = {
      username: formData.personalID,
      firstName: INIT_DATA.firstName,
      lastName: INIT_DATA.lastName,
    };

    try {
      const response = await updateKeyCloak(sub, payload);
    } catch (error) {

    }
  };

  useEffect(() => {
    const fetchInviteData = async () => {
      show();
      try {
        const { data } = await inviteDecode(encodeURIComponent(inviteCode));
        if (data.companyId && Date.now() < parseInt(data.expiresIn)) {
          setFormData((prev) => ({
            ...prev,
            companyId: data.companyId,
            email: data.toUser,
          }));
        }
      } catch (error) {
        if (isAxiosError(error)) {
          toast.error(t(error.response.data));
        }
      } finally {
        hide();
      }
    };

    if (inviteCode) {
      fetchInviteData();
    }
  }, [hide, show, t, inviteCode]);

  const updateFormDataAndValidate = (name, value) => {
    if (name === "personalID" && personalInfo.fullName) {
      // setFormData((prevData) => ({ ...prevData, [name]: value, firstName: '', lastName: '' }));
      // setValidationMessages((prevMessages) => ({ ...prevMessages, firstName: 'common.content-006', lastName: 'common.content-007' }));
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }

    switch (name) {
      // case 'firstName':
      //    setValidationMessages((prevMessages) => ({
      //       ...prevMessages,
      //       firstName: value ? '' : 'common.content-006',
      //    }));
      //    break;

      // case 'lastName':
      //    setValidationMessages((prevMessages) => ({
      //       ...prevMessages,
      //       lastName: value ? '' : 'common.content-007',
      //    }));
      //    break;

      // case "taxCode":
      //   setTaxInfo(INIT_TAX_INFO);
      //   setValidationMessages((prevMessages) => ({
      //     ...prevMessages,
      //     taxCode: value.trim() ? "" : "common.content-026",
      //   }));
      //   break;

      case "taxCode": {
        const taxRegex = /^[0-9-]+$/;

        setValidationMessages((prev) => ({
          ...prev,
          taxCode: !value
            ? "common.content-026"
            : value.length < 10 || value.length > 14
              ? "common.content-187"
              : "",
        }));
        break;
      }

      case "personalID":
        setPersonalInfo(INIT_PERSONAL_INFO);
        setValidationMessages((prevMessages) => ({
          ...prevMessages,
          personalID: value
            ? value.length <= 12
              ? ""
              : "common.content-009"
            : "common.content-008",
        }));
        break;

      case "email":
        setValidationMessages((prevMessages) => ({
          ...prevMessages,
          email: value
            ? EmailRegex.test(value)
              ? ""
              : "validation.email-invalid-format"
            : "validation.email-required",
        }));
        break;

      case "phone":
        setValidationMessages((prevMessages) => ({
          ...prevMessages,
          phone: value
            ? selectedPhoneCountry.phoneRegex.test(value)
              ? ""
              : "common.content-024"
            : "common.content-027",
        }));
        break;
      case "country":
        setValidationMessages((prevMessages) => ({
          ...prevMessages,
          country: value ? "" : "",
        }));
        break;
      case "organizationSize":
        setValidationMessages((prevMessages) => ({
          ...prevMessages,
          organizationSize: value ? "" : "",
        }));
        break;
      default:
        setValidationMessages((prevMessages) => ({
          ...prevMessages,
          password: value
            ? PasswordRegex.test(value)
              ? ""
              : "common.content-012"
            : "common.content-011",
        }));
        break;
    }
  };

  const fetchInfoUser = async (request) => {
    show();
    try {
      const data = await infoGetByPPersonalID(request);

      if (data.data.data.responseCode === 0) {
        const dataInfo = data.data.data.data[0];

        setPersonalInfo({
          ...dataInfo,
          fullName: dataInfo.fullName,
          placeOfOrigin: dataInfo.placeOfBirth,
          placeOfResidence: dataInfo.permanentAddress,
          personalNumber: dataInfo.citizenIdentificationNumber,
          image: dataInfo.profilePicture,
          birthDate: dataInfo.dateOfBirth,
          gender: dataInfo.gender,
          ethnic: dataInfo.ethnicity,
          issuanceDate: dataInfo.issueDate,
          expiryDate: dataInfo.expirationDate,
          nationality: dataInfo.countryName,
        });
        setFormData((prevData) => ({
          ...prevData,
          city: dataInfo.city,
          address: dataInfo.permanentAddress,
        }));
      } else {
        const response = await getInfoByCitizen(request);
        if (response.data.status === 0) {
          const dataInfoIdtt = response.data.personal_informations;
          const newBase64 = dg2ToImage(dataInfoIdtt.dg2_value, 84);
          setPersonalInfo({
            ...dataInfoIdtt,
            fullName: dataInfoIdtt.full_name,
            placeOfOrigin: dataInfoIdtt.place_of_origin,
            placeOfResidence: dataInfoIdtt.place_of_residence,
            personalNumber: dataInfoIdtt.personal_number,
            image: newBase64,
            birthDate: dataInfoIdtt.birth_date
              ? format(
                parse(dataInfoIdtt.birth_date, "dd/MM/yyyy", new Date()),
                "yyyy-MM-dd"
              )
              : "",
            gender: dataInfoIdtt.gender,
            ethnic: dataInfoIdtt.ethnic,
            issuanceDate: dataInfoIdtt.issuance_date
              ? format(
                parse(dataInfoIdtt.issuance_date, "dd/MM/yyyy", new Date()),
                "yyyy-MM-dd"
              )
              : "",
            expiryDate: dataInfoIdtt.expiry_date
              ? format(
                parse(dataInfoIdtt.expiry_date, "dd/MM/yyyy", new Date()),
                "yyyy-MM-dd"
              )
              : "",
          });
          const fullAddress = dataInfoIdtt.place_of_origin;
          const parts = fullAddress.split(",").map((part) => part.trim());
          const province = parts.pop();
          setFormData((prev) => ({
            ...prev,
            city: province,
            address: dataInfoIdtt.place_of_residence || dataInfoIdtt.place_of_origin,
          }));
        } else {
          if (response.data.status === 4028) {
            toast.error(t("common.citizenid-card-not-exists"));
          } else if (response.data?.message) {
            toast.error(
              response.data.message.charAt(0).toUpperCase() +
              response.data.message.slice(1).toLowerCase()
            );
          } else if (data.data.data.responseCode === 1040) {
            toast.error(t("common.no-found-read-card"));
          }
        }
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t("common.network-timeout"));
      }
    } finally {
      hide();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    updateFormDataAndValidate(name, value);
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsSubmitting(true);

      const payload = {
        owner: {
          profilePicture: personalInfo.image || null,
          fullName: personalInfo.fullName,
          personalID: formData.personalID,
          email: formData.email,
          telephone: formData.phone,
          employeeCode: formData.employeeCode,
          dateOfBirth: personalInfo.birthDate,
          gender: personalInfo.gender,
          ethencity: personalInfo.ethnic,
          issueDate: personalInfo.issuanceDate,
          expirationDate: personalInfo.expiryDate,
          city: formData.city,
          permanentAddress: formData.address || null,
          placeOfBirth: null,
          country: formData.country,
          joinDate: "",
          groupIds: [1],
        },
        company: {
          companyName: taxInfo.officialName,
          taxCode: formData.taxCode,
          phone: formData.phone,
          country: formData.country,
          organizationSize: formData.organizationSize,
        },
        langId: localStorage.getItem("i18nextLngId"),
      };

      const response = await signupBusiness(payload);
      console.log("response", response);
      const responseCode = response?.data?.responseCode;
      const result = response?.data?.data?.[0] || response?.data?.singleData;

      if (responseCode === 0 || responseCode === 1077) {
        if (result?.companyId) {
          setHeaderCompanyId(result.companyId);
        }
        await handleUpdateKeycloak();
        toast.success(t("common.signup-successfully"));
        refreshProfile();
      } else {
        toast.error(
          response?.data?.message ||
            response?.data?.data?.message ||
            t("common.something-went-wrong")
        );
      }
    } catch (error) {
      console.log(error);
      if (isAxiosError(error)) {
        const data = error.response?.data;
        const msg =
          (typeof data === "string" ? data : data?.message || data?.error) ||
          t("common.something-went-wrong");
        toast.error(typeof msg === "string" ? (t(msg) !== msg ? t(msg) : msg) : t("common.something-went-wrong"));
      } else {
        toast.error(t("common.something-went-wrong"));
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const checkReadCard = async (cardId) => {
    try {
      const payload = {
        personalID: cardId,
      };
      const checkResponse = await infoGetByPPersonalID(payload);

      if (checkResponse.data.responseCode === 0) {
        handleReadCard(cardId);
      } else {
        toast.error(t("ERRORMSG_1055"));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleReadCard = (cardId) => {
    try {
      setIsSubmitting(true);
      let deviceName = false;
      connectWS.mutate(
        {},
        {
          onSuccess: (data) => {
            setIsMissingSoftware(false);
            setIsSubmitting(false);
            setIsSubmitting(true);
            getDevice.mutate(
              { lang: language },
              {
                onSuccess: (dataReadcard) => {
                  // hide();

                  if (dataReadcard.deviceSN === "54822502250122") {
                    deviceName = true;
                  }
                },
                onError: (error) => {
                  setIsSubmitting(false);
                  toast.error(error);
                },
              }
            );
            readCard.mutate(
              {
                lang: language,
                code: cardId.slice(-6),
                deviceName: deviceName,
              },
              {
                onSuccess: (dataReadcard) => {
                  setIsSubmitting(false);

                  if (
                    dataReadcard.optionalDetails.personalNumber !==
                    formData.personalID
                  ) {
                    return setValidationMessages((prevMessages) => ({
                      ...prevMessages,
                      personalID: "common.content-014",
                    }));
                  }

                  if (dataReadcard.optionalDetails) {
                    const fullName = dataReadcard.optionalDetails.fullName;
                    const fullNameSplit = fullName.split(" ");
                    const lastName = fullNameSplit.slice(0, -1).join(" ");
                    const firstName = fullNameSplit.at(-1);
                    updateFormDataAndValidate("firstName", firstName);
                    updateFormDataAndValidate("lastName", lastName);
                    setPersonalInfo({
                      ...dataReadcard.optionalDetails,
                      image: dataReadcard.image,
                      birthDate: dataReadcard.optionalDetails.birthDate
                        ? format(
                          parse(
                            dataReadcard.optionalDetails.birthDate,
                            "dd/MM/yyyy",
                            new Date()
                          ),
                          "yyyy-MM-dd"
                        )
                        : "",
                      gender: dataReadcard.optionalDetails.gender,
                      ethnic: dataReadcard.optionalDetails.ethnic,
                      issuanceDate: dataReadcard.optionalDetails.issuanceDate
                        ? format(
                          parse(
                            dataReadcard.optionalDetails.issuanceDate,
                            "dd/MM/yyyy",
                            new Date()
                          ),
                          "yyyy-MM-dd"
                        )
                        : "",
                      expiryDate: dataReadcard.optionalDetails.expiryDate
                        ? format(
                          parse(
                            dataReadcard.optionalDetails.expiryDate,
                            "dd/MM/yyyy",
                            new Date()
                          ),
                          "yyyy-MM-dd"
                        )
                        : "",
                    });

                    const fullAddress =
                      dataReadcard.optionalDetails.placeOfOrigin;
                    const parts = fullAddress
                      .split(",")
                      .map((part) => part.trim());

                    const province = parts.pop();

                    setFormData((prev) => ({
                      ...prev,
                      city: province,
                      address: dataReadcard.optionalDetails.placeOfResidence,
                    }));
                    toast.success(t("common.content-013"));
                  }
                },
                onError: (error) => {
                  console.log(error);
                  setIsSubmitting(false);
                  if (error.error === 1102) {
                    toast.error(t("common.CAN"));
                  } else {
                    toast.error(error.message || t("common.content-029"));
                  }
                },
              }
            );
          },
          onError: (error) => {
            console.log(error);
            setIsSubmitting(false);
            setIsMissingSoftware(true);
            toast.error(t("common.content-028"));
          },
        }
      );
    } catch (error) {
      toast.error(t("common.content-029"));
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleCloseDetailTaxID = () => {
    setOpenDetailTaxID(false);
  };

  useEffect(() => {
    setIsMissingSoftware(false);
  }, [formData.personalID]);

  const handleGetInfoByTaxcode = async (taxCode) => {
    try {
      setIsSubmitting(true)
      const contentTaxCode = taxCode.trim();
      const checkTaxInfo = await checkCompany(
        contentTaxCode,
        localStorage.getItem("i18nextLngId")
      );

      if (checkTaxInfo.data.data.responseCode === 0) {
        const { data } = await getInfoByTaxcode(contentTaxCode);

        const info = data.responseData.tax_informations[0];
        if (info) {
          setTaxInfo({
            officialName: info.company_information.official_name,
            issuanceDate: info.company_information.operation_start_date,
            address: info.company_information.address,
            fullName: info.owner_information.full_name,
            taxId: info.company_information.tax_code,
          });
          toast.success(t("common.get-tax-code"));
          // } else {
          //    toast.error(checkTaxInfo.data.data.message);
          // }
        }
      } else {
        toast.error(checkTaxInfo.data.data.message);
      }
    } catch (error) {
      if (isAxiosError(error)) {
        if (error.code === "ECONNABORTED") {
          setValidationMessages((prev) => ({
            ...prev,
            taxCode: t("ERRORMSG_4044"),
          }));
        } else if (error.response?.data) {
          setValidationMessages((prev) => ({
            ...prev,
            taxCode: error.response.data,
          }));
        } else {
          setValidationMessages((prev) => ({
            ...prev,
            taxCode: t("ERRORMSG_4044"),
          }));
        }
      } else {
        setValidationMessages((prev) => ({
          ...prev,
          taxCode: t("ERRORMSG_4044"),
        }));
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleGenerateRandom = () => {
    const valueGen = generateRandomString();
    setFormData({
      ...formData,
      employeeCode: valueGen,
    });
  };

  const handleBlur = async () => {
    if (skipBlurRef.current) {
      skipBlurRef.current = false;
      return;
    }
    if (formData.personalID.trim().length === 12) {
      setonBlurEvent(true);
      fetchInfoUser(formData);
    } else {
      setValidationMessages((prevMessages) => ({
        ...prevMessages,
        personalID: "common.content-009",
      }));
    }
  };

  const handleGetInfomationUser = async () => {
    if (formData.personalID.trim().length === 12) {
      fetchInfoUser(formData);
    } else {
      setValidationMessages((prevMessages) => ({
        ...prevMessages,
        personalID: "common.content-009",
      }));
    }
  };

  const handleCallGenarate = () => {
    handleGenerateRandom();
    setonBlurEvent(true);
    if (!personalInfo.fullName) {
      handleGetInfomationUser();
    }
    // if (formData.personalID.length === 0) {
    //    setValidationMessages((prevMessages) => ({
    //       ...prevMessages,
    //       personalID: '',
    //    }));
    // }
  };

  // const handleGetInfomationUser = async () => {
  //    if (formData.personalID.trim().length === 12) {
  //       fetchInfoUser(formData)
  //    } else {
  //       setValidationMessages((prevMessages) => ({
  //          ...prevMessages,
  //          personalID: 'common.content-009',
  //       }));
  //    }
  // };

  const handleCallGetInfoTaxCode = (taxCode) => {

    handleGetInfoByTaxcode(taxCode);
    setonBlurEvent(true);
    if (!personalInfo.fullName) {
      handleGetInfomationUser();
    }
    // if (formData.taxCode.length === 0) {
    //    setValidationMessages((prevMessages) => ({
    //       ...prevMessages,
    //       taxCode: '',
    //    }));
    // }
  };

  useEffect(() => {
    if (isSubmitting) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isSubmitting]);

  return (
    <div className="relative w-full order-1 lg:order-2 pb-12">
      {/* Logo + Language — giống Login */}
      <div className="flex items-center justify-center gap-4 mb-6">
        <img
          src={logo_light}
          alt="CheckID BioSense"
          width={300}
          height={100}
        />
      </div>

      <div className="flex items-end justify-end gap-4 mb-6">
        <div className="relative">
          <button
            type="button"
            ref={anchorRefLanguage}
            onClick={() => setOpenLanguage((prev) => !prev)}
            className="flex items-center gap-2 px-3 py-2 border border-[#E5E7EB] rounded-xl bg-white hover:bg-gray-50"
            id="signup-language-button"
            aria-controls={openLanguage ? "signup-language-menu" : undefined}
            aria-expanded={openLanguage ? "true" : undefined}
            aria-haspopup="true"
          >
            <img
              src={currentFlag}
              alt={currentLang === "vi" ? "VI" : "EN"}
              className="w-[22px] h-[22px] rounded-full object-cover"
            />
            <ChevronDown10pxSvg
              className={`text-[#404040] transition-transform duration-300 ${
                openLanguage ? "rotate-180" : ""
              }`}
            />
          </button>

          <Popper
            open={openLanguage}
            anchorEl={anchorRefLanguage.current}
            role={undefined}
            placement="bottom-end"
            transition
            disablePortal
            className="z-10"
          >
            {({ TransitionProps }) => (
              <Grow {...TransitionProps}>
                <Paper
                  style={{
                    borderRadius: "8px",
                    marginTop: "8px",
                    minWidth: 120,
                  }}
                >
                  <ClickAwayListener onClickAway={() => setOpenLanguage(false)}>
                    <NavbarLanguageMenuList
                      autoFocusItem={openLanguage}
                      sx={{
                        overflow: "hidden",
                        borderRadius: "8px",
                        ".MuiMenuItem-root": {
                          borderRadius: 0,
                          "&:hover": {
                            borderRadius: 0,
                          },
                          "&:first-of-type:hover": {
                            borderTopLeftRadius: "8px",
                            borderTopRightRadius: "8px",
                          },
                          "&:last-of-type:hover": {
                            borderBottomLeftRadius: "8px",
                            borderBottomRightRadius: "8px",
                          },
                        },
                      }}
                    >
                      <MenuItem onClick={() => handleChangeLanguage("en")}>
                        <div className="flex items-center gap-2 whitespace-nowrap">
                          <img
                            src={US}
                            alt="EN"
                            className="w-5 h-5 rounded-full object-cover shrink-0"
                          />
                          <span>{t("common.languageEn")}</span>
                        </div>
                      </MenuItem>
                      <MenuItem onClick={() => handleChangeLanguage("vi")}>
                        <div className="flex items-center gap-2 whitespace-nowrap">
                          <img
                            src={VN}
                            alt="VI"
                            className="w-5 h-5 rounded-full object-cover shrink-0"
                          />
                          <span>{t("common.languageVi")}</span>
                        </div>
                      </MenuItem>
                    </NavbarLanguageMenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>

      <p className="font-extrabold text-[24px] !leading-none text-[#1F2937]">
        {t("sign-up.create-account")}
      </p>
      <p className="pt-6 font-medium">
        {t("sign-up.provide-personal-information")}
      </p>
      <form>
        <div className="grid grid-cols-2 gap-x-6 sm:grid-cols-6 pt-5">
          <div className="col-span-full">
            <div className="flex-grow">
              <div className="">
                <label className="block text-sm">
                  {t("common.personal-id")}
                  <span className="text-[#EF4444] ml-1">*</span>
                </label>

                <div className="mt-2 relative flex items-center">
                  <input
                    disabled={isSubmitting}
                    type="number"
                    name="personalID"
                    className={`form-control no-spin-buttons relative z-40 h-10 pr-12 ${!!validationMessages.personalID ? "invalid" : ""
                      }`}
                    value={formData.personalID}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    onKeyDown={(e) => {
                      if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                        e.preventDefault();
                      }
                    }}
                  />
                  <PrimaryButton
                    disabled={
                      formData.personalID?.length !== 12 || isSubmitting
                    }
                    className="!absolute inset-y-0 right-0 !rounded-none !rounded-r-md !text-nowrap z-50 w-28 h-10"
                    onMouseDown={() => (skipBlurRef.current = true)}
                    onClick={() => handleReadCard(formData.personalID)}
                  // onClick={() => checkReadCard(formData.personalID)}
                  >
                    {t("button.read-card")}
                  </PrimaryButton>
                  {/* <PrimaryButton
                              // disabled={!!validationMessages.personalID || !formData.personalID}
                              disabled={formData.personalID?.length !== 12}
                              className='!absolute inset-y-0 right-0 !rounded-none !rounded-r-md !text-nowrap z-50 w-28'
                              onClick={() => handleReadCard(formData.personalID)}
                           >
                              {t('button.read-card')}
                           </PrimaryButton> */}
                </div>
                {validationMessages.personalID && (
                  <p className="text-[14px] text-red-500 mt-1">
                    {t(validationMessages.personalID)}
                  </p>
                )}

                {isMissingSoftware && (
                  <div className="col-span-full px-3 py-2 bg-[#f8d7da] rounded-lg mt-2">
                    <p className="text-[#EF4444] text-xs">
                      {t("common.content-018")}
                    </p>
                    <Link
                      className="!text-[#EF4444] !text-xs !decoration-[#EF4444]"
                      href={dataConfig.url_download_checkid}
                      target="_blank"
                    >
                      {t("common.content-019")}
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </div>
          {personalInfo.fullName && (
            <>
              <div className="col-span-full pt-2">
                <button
                  type="button"
                  className="flex items-center gap-2 text-blue-500 font-semibold pt-1.5"
                  onClick={() => setOpen(true)}
                >
                  <OpenInNewIcon className="!w-4 !h-4" />
                  {t("common.content-128")}
                </button>
              </div>

              <div className="col-span-full pt-2">
                <CustomInput
                  // required
                  title={t("common.full-name")}
                  inputType="text"
                  name="fullName"
                  // handleInputChange={handleChange}
                  readOnly
                  value={personalInfo.fullName}
                />
              </div>
              {/* <div className='col-span-full  pt-3'>
                        <CustomInput
                           // required
                           name='lastName'
                           inputType='text'
                           value={formData.lastName}
                           readOnly
                           handleInputChange={handleInputChange}
                           title={t('common.last-name')}
                        />
                     </div> */}
            </>
          )}
          <div className="col-span-full pt-3">
            <CustomInput
              title={t("common.email-address")}
              inputType="text"
              name="email"
              // disabled={true}
              readOnly
              value={formData.email}
            />
          </div>
          <div className="col-span-full space-y-2  pt-3">
            <label className="block">
              {t("common.phone")}
              <span className="text-[#EF4444] ml-1">*</span>
            </label>
            <div className="relative flex items-center h-10">
              <div className="flex items-center gap-1 ps-3.5 relative z-10 bg-transparent">
                <img
                  src={selectedPhoneCountry.nationFlag}
                  alt=""
                  className="w-6"
                />
                <span className="text-black">
                  {selectedPhoneCountry.callingCode}
                </span>
              </div>
              <input
                className={`absolute inset-[-2px] form-control ${!!validationMessages.phone ? "invalid" : ""
                  } ${formData.phone && !validationMessages.phone ? "success" : ""
                  }`}
                value=""
                onChange={() => { }}
              />
              <input
                type="number"
                placeholder={selectedPhoneCountry.placeHolder}
                name="phone"
                className="no-spin-buttons relative z-10 flex-1 h-full outline-none px-3.5 border-none rounded-r-md bg-transparent"
                onChange={handleInputChange}
                value={formData.phone}
              />
              {formData.phone && !validationMessages.phone && (
                <span className="absolute inset-y-0 right-0 px-3 py-2.5">
                  <DoneIcon fontSize="small" className="text-green-500" />
                </span>
              )}
              {!!validationMessages.phone && (
                <span className="absolute inset-y-0 right-0 px-3 py-2.5">
                  <ErrorIcon fontSize="small" className="text-red-500" />
                </span>
              )}
            </div>
            {validationMessages.phone && (
              <p className="text-sm text-red-500 mt-1">
                {t(validationMessages.phone)}
              </p>
            )}
          </div>
          <div className="col-span-full">
            <div className="flex-grow">
              <div className=" pt-5">
                <label className="block text-sm">
                  {t("common.employee-code")}
                  {/* <span className='text-[#EF4444] ml-1'>*</span> */}
                </label>
                <div className="mt-2 relative flex items-center">
                  <input
                    disabled={isSubmitting}
                    required
                    type="text"
                    name="employeeCode"
                    className={`form-control no-spin-buttons relative h-10 z-40 pr-12`}
                    value={formData.employeeCode}
                    // onChange={handleInputChange}
                    onChange={(e) => {
                      const value = e.target.value
                        .toUpperCase()
                        .replace(/[^A-Z0-9]/g, "");
                      if (value.length <= 6) {
                        handleInputChange({
                          target: { name: "employeeCode", value },
                        });
                      }
                    }}
                  />

                  <PrimaryButton
                    // disabled={!formData.taxCode}
                    // className='!absolute inset-y-0 right-0 !rounded-none !rounded-r-md !text-nowrap z-50'
                    className="!absolute inset-y-0 right-0 !rounded-none !rounded-r-md !text-nowrap z-50 w-28 h-10"
                    disabled={isSubmitting}
                    onMouseDown={() => (skipBlurRef.current = true)}
                    // onClick={() => handleGenerateRandom()}
                    onClick={() => handleCallGenarate()}
                  >
                    {t("button.generate")}
                  </PrimaryButton>
                </div>
                {/* {validationMessages.taxCode && <p className='text-[14px] text-red-500 mt-1'>{t(validationMessages.taxCode)}</p>} */}
              </div>
            </div>
          </div>

          <div className="col-span-full pt-3">
            <div className="h-[2px] bg-gray-300 w-full" />
          </div>

          <div className="col-span-full">
            <div className="flex-grow">
              <div className=" pt-3">
                <label className="block text-sm">
                  {t("common.tax-code-company")}
                  <span className="text-[#EF4444] ml-1">*</span>
                </label>
                <div className="mt-2 relative flex items-center">
                  <input
                    required
                    type="text"
                    name="taxCode"
                    className={`form-control no-spin-buttons relative z-40 h-10 pr-12 ${!!validationMessages.taxCode ? "invalid" : ""
                      } `}
                    value={formData.taxCode}
                    //   onChange={handleInputChange}
                    onChange={(e) => {
                      const val = e.target.value;

                      // chỉ cho phép số và -
                      if (/^[0-9-]*$/.test(val) && val.length <= 14) {
                        // Reset taxInfo khi gõ số mới
                        if (taxInfo?.officialName) {
                          setTaxInfo({});
                        }

                        handleInputChange(e);
                      }
                    }}

                    disabled={isSubmitting}
                  />

                  <PrimaryButton
                    disabled={!formData.taxCode || isSubmitting}
                    // className='!absolute inset-y-0 right-0 !rounded-none !rounded-r-md !text-nowrap z-50'
                    className="!absolute inset-y-0 right-0 !rounded-none !rounded-r-md !text-nowrap z-50 w-28 h-10"
                    onMouseDown={() => (skipBlurRef.current = true)}
                    // onClick={() => handleGetInfoByTaxcode(formData.taxCode)}
                    onClick={() => handleCallGetInfoTaxCode(formData.taxCode)}
                  >
                    {t("common.content-127")}
                  </PrimaryButton>
                </div>
                {validationMessages.taxCode && (
                  <p className="text-[14px] text-red-500 mt-1">
                    {t(validationMessages.taxCode)}
                  </p>
                )}
              </div>
            </div>
          </div>
          {taxInfo.officialName && (
            <div className="col-span-full">
              <button
                type="button"
                className="flex items-center gap-2 text-blue-500 font-semibold py-2.5"
                onClick={() => setOpenDetailTaxID(true)}
                onMouseDown={() => (skipBlurRef.current = true)}
              >
                <OpenInNewIcon className="!w-4 !h-4" />
                {t("common.content-138")}
              </button>
            </div>
          )}

          <div className="col-span-full space-y-2  pt-3">
            <label className="block">{t("common.country")}</label>
            <CustomSelect
              readOnly
              name="country"
              className="!bg-white"
              value={formData.country}
              options={countries}
              dataType="country"
              onChange={(e) => {
                const value = e.target.value;
                const selectedCountryData = countries.find(
                  (country) => country.alpha3Code === value
                );
                setSelectedPhoneCountry({
                  ...selectedCountryData,
                  phoneRegex: new RegExp(selectedCountryData.phoneRegex),
                });
                updateFormDataAndValidate(
                  "country",
                  selectedCountryData.alpha3Code
                );
              }}
            />
          </div>

          <div className="col-span-full pt-3 space-y-2">
            <label className="block">{t("common.organization-size")}</label>

            <div className="flex justify-between items-stretch border border-[#C9C9C9] rounded-md [&>*:not(:first-child)]:border-s">
              {COMPANY_RANGE.map((r, index) => (
                <div
                  key={index}
                  className={`organization-size ${formData.organizationSize === r.value ? "active" : ""
                    }`}
                  onClick={() =>
                    updateFormDataAndValidate("organizationSize", r.value)
                  }
                >
                  <p className="text-center">{r.display}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="col-span-full pt-3 flex items-start gap-2">
            <input
              type="checkbox"
              id="agree"
              checked={agree}
              onChange={async (e) => {
                const checked = e.target.checked;
                setAgree(checked);

                if (checked) {
                  const ip = await getPublicIP();

                  const payload = {
                    ipPublic: ip,
                    time: new Date().toISOString(), // UTC +0
                    status: "AGREED",
                  };

                  setConsentData(payload);
                } else {
                  setConsentData(null);
                }
              }}
              className="mt-1 scale-125"
            />

            <label htmlFor="agree" className="text-sm flex flex-wrap items-center gap-1">
              <span>{t("common.i-agree")}</span>

              <StyledLink
                href="https://mobile-id.vn/vi/setup"
                target="_blank"
                className="!text-[#3B82F6]"
              >
                {t("not-login-page.terms-and-conditions")}
              </StyledLink>

              <span>|</span>

              <StyledLink
                href="https://mobile-id.vn/vi/privacy-policy"
                target="_blank"
                className="!text-[#3B82F6]"
              >
                {t("not-login-page.privacy-policy")}
              </StyledLink>
            </label>
          </div>

          <div className="col-span-full pt-3">
            <PrimaryButtonFullWidth
              onClick={handleSubmit}
              disabled={
                !personalInfo.fullName || !formData.phone || validationMessages.phone ||
                !taxInfo.officialName ||
                !agree
              }
            >
              {t("button.continue")}
            </PrimaryButtonFullWidth>
          </div>

        </div>
      </form>

      <CustomDialog maxWidth={"xl"} open={open} onClose={handleClose}>
        <DialogTitle>
          <div className="flex justify-between">
            <div className="flex items-center gap-4">
              <p className="text-xl font-semibold text-[#1A1D1F]">
                {t("common.content-128")}
              </p>
            </div>
            <GrayIconButton onClick={handleClose}>
              <CloseIcon />
            </GrayIconButton>
          </div>
        </DialogTitle>
        <DialogContent className="grid grid-cols-1 sm:grid-cols-2 gap-x-3 relative">
          <div className="col-span-full pt-6">
            <img
              src={`data:image/png;base64,${personalInfo.image}`}
              alt="avatar"
              className="mx-auto w-44 h-[180px] border border-gray-200 rounded p-[5px] object-cover"
            />
          </div>

          {ACCOUNT_CONFIGS.personalInfo.map(({ key, title, className }) => {
            let value = personalInfo[key];

            // Chuyển định dạng cho các trường ngày
            if (["issuanceDate", "expiryDate", "birthDate"].includes(key)) {
              value = formatDate(value, generalSettingDateFormat);
            }

            return (
              <CustomInput
                key={key}
                readOnly
                containerClassName={className}
                title={t(title)}
                inputType="text"
                value={value}
                className="h-10 mb-4"
              />
            );
          })}

        </DialogContent>

        <DialogActions>
          <div className="flex gap-2 px-4 py-4">
            <ControlpanelSecondaryButton onClick={() => setOpen(false)}>
              <CloseIcon />
              <p>{t("button.close")}</p>
            </ControlpanelSecondaryButton>
          </div>
        </DialogActions>
      </CustomDialog>

      {/* tax info */}

      <CustomDialog
        maxWidth={"xl"}
        open={openDetailTaxID}
        onClose={handleCloseDetailTaxID}
      >
        <DialogTitle>
          <div className="flex justify-between">
            <div className="flex items-center gap-4">
              <p className="text-xl font-semibold text-[#1A1D1F]">
                {t("common.content-138")}
              </p>
            </div>
            <GrayIconButton onClick={handleCloseDetailTaxID}>
              <CloseIcon />
            </GrayIconButton>
          </div>
        </DialogTitle>
        {/* <DialogContent className='grid grid-cols-1 sm:grid-cols-2 gap-x-10 relative'>
               {ACCOUNT_CONFIGS.taxInfo.map(({ key, title, className }) => (
                  <CustomInput key={key} readOnly containerClassName={className} title={t(title)} inputType='text' value={taxInfo[key]} />
               ))}
            </DialogContent> */}
        <DialogContent className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 relative mt-6">
          {ACCOUNT_CONFIGS.taxInfo.map(({ key, title, className }) => (
            <CustomInput
              key={key}
              readOnly
              containerClassName={className}
              title={t(title)}
              inputType="text"
              value={taxInfo[key]}
              tooltip={key === "address" ? taxInfo[key] : undefined}
              className="h-10 mb-4"
            />
          ))}
        </DialogContent>

        <DialogActions>
          <div className="flex gap-2 px-4 py-4">
            <ControlpanelSecondaryButton onClick={handleCloseDetailTaxID}>
              <CloseIcon />
              <p>{t("button.close")}</p>
            </ControlpanelSecondaryButton>
          </div>
        </DialogActions>
      </CustomDialog>

      {isSubmitting && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CustomSpinner loading={true} />
        </div>
      )}
    </div>
  );
};

export default Signup;
